import { render, staticRenderFns } from "./AutoReviewModal.vue?vue&type=template&id=5bdea630&scoped=true"
import script from "./AutoReviewModal.vue?vue&type=script&lang=js"
export * from "./AutoReviewModal.vue?vue&type=script&lang=js"
import style0 from "./AutoReviewModal.vue?vue&type=style&index=0&id=5bdea630&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdea630",
  null
  
)

export default component.exports